








import { Component, Vue } from 'vue-property-decorator'
import TheUploadDocument from '../component/TheUploadDocument.vue'
import { namespace } from 'vuex-class'

const kycSectionStore = namespace('KYCSectionStore')

@Component({
  components: {
    TheUploadDocument
  }
})
export default class UploadDocument extends Vue {
  @kycSectionStore.Mutation
  public updateTotalUploadedPdf!: (list: []) => void

  @kycSectionStore.State
  private totalUploadedPdf: []

  private kycFormOid = ''

  private documentTypeOption = [{
    section: 'Type of Document (New Business)',
    options: [
      { value: 'NRIC' },
      { value: 'Application Forms' },
      { value: 'Policy Illustration' },
      { value: 'Personal Financial Review' },
      { value: 'Birth Certificate' },
      { value: 'Medical Reports' },
      { value: 'Cheque Image' },
      { value: 'Terms & Conditions' },
      { value: 'Others' }
    ]
  }, {
    section: 'Type of Document (Follow Up)',
    options: [
      { value: 'Service Recovery' },
      { value: 'Claims' },
      { value: 'Change of FAR' },
      { value: 'Nomination Form' }
    ]
  }]

  updateAppendixList (evt) {
    this.updateTotalUploadedPdf(evt)
  }

  created () {
    this.kycFormOid = this.$route.params.formOid
  }
}
